export const CHANGED_GAME_FOR_CUSTOM_MAPPING_PAGE =
  "CHANGED_GAME_FOR_CUSTOM_MAPPING_PAGE";
export const CHANGED_ACTIVE_CONTROLLER_FOR_CUSTOM_MAPPING_PAGE =
  "CHANGED_ACTIVE_CONTROLLER_FOR_CUSTOM_MAPPING_PAGE";
export const CHANGED_CONTROLLER_MAPPING = "CHANGED_CONTROLLER_MAPPING";
